const LAST_EXPORT_STORAGE_KEY = '__last_export_id__';
const LAST_EXPORT_MODAL_STATE_KEY = '__last_export_modal_open__';

const hasBrowserStorage = (): boolean => {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
};

export const setLastExportId = (id: string): void => {
  if (!hasBrowserStorage()) {
    return;
  }
  try {
    window.localStorage.setItem(LAST_EXPORT_STORAGE_KEY, id);
  } catch {
  }
};

export const getLastExportId = (): string | undefined => {
  if (!hasBrowserStorage()) {
    return undefined;
  }
  try {
    const value = window.localStorage.getItem(LAST_EXPORT_STORAGE_KEY);
    return value || undefined;
  } catch {
    return undefined;
  }
};

export const setExportModalOpen = (isOpen: boolean): void => {
  if (!hasBrowserStorage()) {
    return;
  }
  try {
    window.localStorage.setItem(LAST_EXPORT_MODAL_STATE_KEY, isOpen ? 'true' : 'false');
  } catch {
  }
};

export const isExportModalOpen = (): boolean => {
  if (!hasBrowserStorage()) {
    return false;
  }
  try {
    const value = window.localStorage.getItem(LAST_EXPORT_MODAL_STATE_KEY);
    return value === 'true';
  } catch {
    return false;
  }
};

export const clearExportState = (): void => {
  if (!hasBrowserStorage()) {
    return;
  }
  try {
    window.localStorage.removeItem(LAST_EXPORT_STORAGE_KEY);
    window.localStorage.removeItem(LAST_EXPORT_MODAL_STATE_KEY);
  } catch {
  }
};
